export default {
  listfiscalNature: [],
  fiscalNature: {
    ativo: true,
    id: 0,
    nome: '',
  },
}
